import React from 'react';

import { connect } from "react-redux";

const Part2 = (props) => {
    return (<div>
        <h3>{props.b}</h3>
    </div>);
}

export default connect(state => state, null)(Part2);